import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import { getEnvironmentLabel } from "./utils/environment";
import Dashboard from "./pages/view/Dashboard";
import UserPage from "./pages/view/UserPage";
import TestPage from "./pages/view/TestPage";
import UploadPage from "./pages/view/UploadPages";
import ChartPage from "./pages/view/ChartPage";
import PredictionPage from "./pages/view/PredictionPage";
import AllUsersPredictionPage from "./pages/view/AllUsersPredictionPage";
import UserPredictionPage from "./pages/view/UserPredictionPage";
import AiSettingsPage from "./pages/view/AiSettingsPage";
import Login from "./pages/auth/LoginPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import OTPVerificationPage from "./pages/auth/OTPVerificationPage";
import NewPasswordPage from "./pages/auth/NewPasswordPage";
import ProtectedRoute from "./routes/protectedRoutes.js";
import { toast } from "react-toastify";

function App() {
  // Set dynamic title based on backend URL
  useEffect(() => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const title = getEnvironmentLabel(backendUrl);
    document.title = title;
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/otp-verification" element={<OTPVerificationPage />} />
        <Route path="/new-password" element={<NewPasswordPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />}>
            <Route index element={<UserPage />} />
            <Route path="users" element={<UserPage />} />
            <Route path="test" element={<TestPage />} />
            <Route path="upload" element={<UploadPage />} />
            <Route path="charts" element={<ChartPage />} />
            <Route path="prediction" element={<AllUsersPredictionPage />} />
            <Route path="prediction/:id" element={<UserPredictionPage />} />
            <Route path="ai-settings" element={<AiSettingsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;